import * as Api from "../../Api/Api";
import * as actionTypes from "../actions/actionTypes";

const getDashBoardStart = () => {
  return {
    type: actionTypes.GET_DASHBOARD_START,
  };
};

const getDashBoardSuccess = (data) => {
  return {
    type: actionTypes.GET_DASHBOARD_SUCCESS,
    data,
  };
};

const getDashBoardFail = (err) => {
  return {
    type: actionTypes.GET_DASHBOARD_FAIL,
    err,
  };
};

export const getDashBoard = (where) => {
  return async (dispatch) => {
    dispatch(getDashBoardStart());

    try {
      const res = Api.apiCallPostFunction(
        "POST",
        `${
          process.env.REACT_APP_SITE_PRODUCTION_URL + "/api/user/userdashboard"
        }`,
        "application/x-www-form-urlencoded",
        {
          UserId: sessionStorage.getItem("userId"),
          Role: sessionStorage.getItem("role"),
        }
      );

      const finaldata = await res;

      if (finaldata.data.errorCode === "200") {
        dispatch(getDashBoardSuccess(finaldata.data));
      } else if (finaldata.data.errorCode === "404") {
        sessionStorage.clear();
        where("/login");
        dispatch(getDashBoardFail(finaldata.data));
      } else {
        sessionStorage.clear();
        where("/login");
        dispatch(getDashBoardFail(finaldata.data));
      }
    } catch (e) {
      sessionStorage.clear();
      where("/login");
      dispatch(getDashBoardFail({ msg: "something went wrong", error: e }));
    }
  };
};

//distributor dashboard
const getDistributorDashBoardStart = () => {
  return {
    type: actionTypes.GET_DASHBOARD_START,
  };
};

const getSuperDistributorDashBoardStart = () => {
  return {
    type: actionTypes.GET_SUPER_DASHBOARD_START,
  };
};

const getDistributorDashBoardSuccess = (data) => {
  return {
    type: actionTypes.GET_DASHBOARD_SUCCESS,
    data,
  };
};

const getDistributorDashBoardFail = (err) => {
  return {
    type: actionTypes.GET_DASHBOARD_FAIL,
    err,
  };
};

export const getDistributorDashBoard = (where) => {
  return async (dispatch) => {
    dispatch(getDistributorDashBoardStart());
    dispatch(getSuperDistributorDashBoardStart());

    try {
      const res = Api.apiCallPostFunction(
        "POST",
        `${
          process.env.REACT_APP_SITE_PRODUCTION_URL + "/api/user/userdashboard"
        }`,
        "application/x-www-form-urlencoded",
        {
          UserId: sessionStorage.getItem("userId"),
          Role: sessionStorage.getItem("role"),
        }
      );

      const finaldata = await res;

      if (finaldata.data.errorCode === "200") {
        dispatch(getDistributorDashBoardSuccess(finaldata.data));
      } else if (finaldata.data.errorCode === "404") {
        dispatch(getDistributorDashBoardFail(finaldata.data));
        sessionStorage.clear();
        where("/login");
      } else {
        dispatch(getDistributorDashBoardFail(finaldata.data));
        sessionStorage.clear();
        where("/login");
      }
    } catch (e) {
      sessionStorage.clear();
      where("/login");
      dispatch(
        getDistributorDashBoardFail({ msg: "something went wrong", error: e })
      );
    }
  };
};
